import '@/styles/main.scss';
import { ref } from 'vue';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi-svg';
import { useI18n } from 'vue-i18n';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import { createRulesPlugin } from 'vuetify/labs/rules'

const zooingvar: ThemeDefinition = {
    dark: false,
    colors: {
        primary: '#e46425', //'#7ec9aa', // '#ff9800', #e46425
        secondary: '#00bcd4',
        accent: '#cddc39',
        error: '#f44336',
        warning: '#607d8b',
        info: '#009688',
        success: '#8bc34a',
        avian: '#e69527', //#55380E, #99641A, #879E72, #F4BD37, #497591
        reptile: '#879e72'//'#e46425',
    }
}

export default defineNuxtPlugin(async (nuxtApp: NuxtApp) => {
    console.log('[Vuetify]: Init.');
    const i18n = { global: nuxtApp.$i18n };

    const vuetify = createVuetify({
        ssr: false,
        theme: {
            defaultTheme: 'zooingvar',
            themes: {
                zooingvar: zooingvar
            }
        },
        icons: {
            defaultSet: 'mdi',
            aliases: {
                ...aliases,
            },
            sets: {
                mdi
            }
        },
        locale: {
            adapter: createVueI18nAdapter({ i18n, useI18n }),
        },
    });

    nuxtApp.vueApp.use(createRulesPlugin({ /* options */ }, vuetify.locale))

    nuxtApp.vueApp.use(vuetify);

    const appTop = ref(true);
    nuxtApp.vueApp.provide('appTop', appTop);
})